module.exports = "<v-button (onClick)=applyActions() class=primary [disabled]=disabled>{{ buttonString }}</v-button> ";